<template>
    <div class="hero-search-form dst">
        <div class="hero-search-form__wrapper lg:tw-grid lg:tw-grid-cols-3 lg:tw-gap-6 tw-text-white lg:tw-w-[912px]">
            <div class="hero-search-form__item hero-search-form__item--price">
                <dk-range-slider
                    :nouislider-opts="options"
                    format="price"
                    @end="setPrices"
                    @change="setPrices"
                    @slide="setPrices"
                >
                    <template slot-scope="{ fromText, toText }">
                        <div class="dk-range-slider__values tw-flex tw-justify-between subtitle-sm">
                            <div class="dk-range-slider__from">
                                {{ fromText }}
                            </div>
                            <span class="hero-search-form__price-claim tw-font-semibold">
                                {{ $t('hero-search-form.your-budget') }}
                            </span>
                            <div class="dk-range-slider__to">
                                {{ toText }}
                            </div>
                        </div>
                    </template>
                </dk-range-slider>
            </div>
            <dk-select
                v-model="selectedBodyTypes"
                class="hero-search-form__item--bodytype tw-my-6 lg:tw-my-0 tw-bg-white"
                :options="types"
                :property-label="'label'"
                :property-track-by="'value'"
                :placeholder="$t('hero-search-form.lets-start')"
                :multiple="true"
                :text-apply="ctaButtonText"
                :text-clear-all="$t('hero-search-form.clear')"
                @click-apply="goToSearchPage"
            />
            <dk-button
                class="hero-search-form__submit tw-w-full tw-py-3 tw-px-6 !tw-h-auto !tw-text-lg tw-leading-sm"
                :disabled="isBusy"
                @click="goToSearchPage"
            >
                <span>{{ ctaButtonText }}</span>
                <dk-icon
                    v-if="isBusy"
                    class="tw-ml-2"
                    name="spinner"
                    size="s"
                    :is-spinning="true"
                />
            </dk-button>
        </div>
    </div>
</template>
<script>
import merge from 'lodash.merge';
import { stringifyUrl } from '@v4/common/utils/url';
import DkButton from '@v4/common/components/atoms/DkButton.vue';
import DkRangeSlider from '@v4/common/components/molecules/DkRangeSliderDST.vue';
import DkSelect from '@v4/common/components/atoms/DkSelect.vue';
import { navigateTo } from '@v4/http/request';
import DkIcon from '@v4/common/components/atoms/DkIcon.vue';
import { pushGtagEvent } from '@v4/common/utils/google-analytics';

export default {
    name: 'HeroSearchForm',
    components: {
        DkButton,
        DkSelect,
        DkRangeSlider,
        DkIcon,
    },
    props: {
        /**
         * [DkRangeSlider](http://localhost:6060/#/Molecules/DkRangeSlider) options
         */
        sliderOpts: {
            type: Object,
            default() {
                return {
                    start: [0, 100000],
                    range: {
                        min: [0, 100],
                        '0.1%': [0, 100],
                        '20%': [20000, 200],
                        '50%': [25000, 500],
                        '70%': [50000, 1000],
                        '85%': [80000, 2000],
                        max: [100000],
                    },
                };
            },
        },
        /**
         * Body types
         */
        bodyTypes: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Search URL
         */
        searchUrl: {
            type: String,
            required: true,
        },
        /**
         * Minimum DKRangeSlider range
         */
        minimumRange: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            lowestPrice: [],
            isBusy: false,
            types:
                (this.bodyTypes.elements &&
                    this.bodyTypes.elements.map((item) => ({
                        label: item.name,
                        value: item.query_arg,
                    }))) ||
                [],
            selectedBodyTypes: [],
            abc: [],
        };
    },
    computed: {
        options() {
            const parsedMinRange = parseInt(this.minimumRange, 10);

            return {
                range: merge(this.sliderOpts.range, { '0.1%': [parsedMinRange, 100] }),
                start: merge(this.sliderOpts.start, [parsedMinRange, 100000]),
            };
        },
        ctaButtonText() {
            return this.$t('hero-search-form.lets-start');
        },
    },
    methods: {
        navigateTo,
        setPrices(...args) {
            this.lowestPrice = args[0][2];
        },
        cleanFilters() {
            if (!this.canCleanFilters) {
                return;
            }

            this.types.forEach((item) => {
                item.checked = false;
            });
        },
        goToSearchPage() {
            pushGtagEvent('click_find_auto', null, null, {
                // eslint-disable-next-line camelcase
                body_type: this.buttonText,
                // eslint-disable-next-line camelcase
                price_range: `${this.lowestPrice[0]} - ${this.lowestPrice[1]}`,
                // eslint-disable-next-line camelcase
                cta: this.ctaButtonText,
            });

            const separator = this.bodyTypes.separator || '|';
            const queryArg = this.bodyTypes.queryArg || 'bodyTypeGrouped';
            const query = {};

            if (this.selectedBodyTypes.length > 0) {
                query[queryArg] = this.selectedBodyTypes.map((item) => item.value).join(separator);
            }

            if (this.lowestPrice.length) {
                const minPrice = this.lowestPrice[0];
                const maxPrice = this.lowestPrice[1];
                query.lowestPrice = [minPrice, maxPrice].join(',');
            }

            const url = stringifyUrl({ url: this.searchUrl, query });
            this.navigateTo(url);

            this.types.forEach((item) => {
                item.disabled = true;
            });
            this.isBusy = true;
        },
    },
};
</script>
